import { Button, Tooltip, TooltipProps } from 'antd';
import type { ButtonProps } from 'antd/lib/button';
import React from 'react';
import { LinkProps } from 'react-router-dom';
import styled from 'styled-components';
import { LocationTo } from '../../core/router/TypedRoute';
import { LinkButton } from './LinkButton';

const StyledButton = styled(Button)`
  padding: 6.4px 0;
  height: 40px;
  width: 40px;
`;
const StyledButtonLink = styled(LinkButton)`
  padding: 6.4px 0;
  height: 40px;
  width: 40px;
`;
const IconWrapperButtonIcon = styled.span`
  &&& {
    font-size: 20px;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export interface ButtonIconProps extends Omit<ButtonProps, 'children'> {
  to?: LinkProps['to'];
  // linkProps?: Omit<LinkProps, 'to'>;
  tooltip?: TooltipProps['title'];
  tooltipProps?: Omit<TooltipProps, 'title'>;
}

export function ButtonIcon(props: ButtonIconProps) {
  const {
    to,
    tooltip,
    icon,
    // onClick,
    // linkProps,
    tooltipProps,
    ...buttonProps
  } = props;
  if (!icon) return null;

  const onClick = to ? undefined : props.onClick;
  const baseButton = (
    <StyledButton type="link" {...buttonProps} {...onClick}>
      <IconWrapperButtonIcon className="anticon">{icon}</IconWrapperButtonIcon>
    </StyledButton>
  );
  const buttonLink = (
    <StyledButtonLink type="link" {...buttonProps} to={to as LocationTo}>
      <IconWrapperButtonIcon className="anticon">{icon}</IconWrapperButtonIcon>
    </StyledButtonLink>
  );
  const button = to ? buttonLink : baseButton;
  return tooltip ? (
    <Tooltip
      overlayClassName="button-icon-tooltip"
      title={tooltip}
      {...tooltipProps}
      children={button}
    />
  ) : (
    button
  );
  // return to ? <Link to={to} {...linkProps} children={button} /> : button;
  // return button
}
